var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuthor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58438",
    "data-name": "Group 58438",
    transform: "translate(-1072 -94)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7990",
    "data-name": "Rectangle 7990",
    width: 70,
    height: 70,
    rx: 17,
    transform: "translate(1072 94)",
    fill: "#f5fbfa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_58437",
    "data-name": "Group 58437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58436",
    "data-name": "Group 58436",
    transform: "translate(1092.467 107.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42418",
    "data-name": "Path 42418",
    d: "M173.5,21.774a2.909,2.909,0,0,0,2.332-2.284.052.052,0,0,1,.1,0,2.909,2.909,0,0,0,2.332,2.284.051.051,0,0,1,0,.1,2.909,2.909,0,0,0-2.332,2.285.052.052,0,0,1-.1,0,2.909,2.909,0,0,0-2.332-2.285.051.051,0,0,1,0-.1Z",
    transform: "translate(-172.509 -14.349)",
    fill: "#fc657e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42419",
    "data-name": "Path 42419",
    d: "M183.858,108.928a1.852,1.852,0,0,0,1.484-1.454.033.033,0,0,1,.066,0,1.851,1.851,0,0,0,1.484,1.454.033.033,0,0,1,0,.064,1.852,1.852,0,0,0-1.484,1.454.033.033,0,0,1-.066,0,1.851,1.851,0,0,0-1.484-1.454.033.033,0,0,1,0-.064Z",
    transform: "translate(-183.83 -84.004)",
    fill: "#f5c84c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_528",
    "data-name": "Ellipse 528",
    cx: 0.885,
    cy: 0.885,
    r: 0.885,
    transform: "translate(32.405 24.7)",
    fill: "#fc657e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_529",
    "data-name": "Ellipse 529",
    cx: 0.885,
    cy: 0.885,
    r: 0.885,
    transform: "translate(6.642 0)",
    fill: "#87d147"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42420",
    "data-name": "Path 42420",
    d: "M40.792,118.7h-.611v-.611a.827.827,0,0,0-1.655,0v.611h-.61a.827.827,0,0,0,0,1.655h.61v.611a.827.827,0,0,0,1.655,0v-.611h.611a.827.827,0,1,0,0-1.655Z",
    transform: "translate(-9.203 -101.522)",
    fill: "#70d6f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_58435",
    "data-name": "Group 58435",
    transform: "translate(968.5 108.411)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42421",
    "data-name": "Path 42421",
    d: "M208.317,18.564a4.921,4.921,0,0,0,1.876-.5.108.108,0,0,0,.01-.186,2.251,2.251,0,0,1-.708-2.338c1.263-4.945,6.65-7.146,10.2-8.033a.382.382,0,0,1,.469.3,24.851,24.851,0,0,1,.119,7.911,7.684,7.684,0,0,1-1.094,3.291,3.067,3.067,0,0,1-2.682,1.432.108.108,0,0,0-.109.157,5.142,5.142,0,0,0,1.33,1.628.374.374,0,0,1,.127.4c-.84,2.83-4.818,7.878-7.91,7.489s-2.662-8.184-1.974-11.264a.376.376,0,0,1,.341-.294Z",
    transform: "translate(-72.489 -6.883)",
    fill: "#00b248"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42422",
    "data-name": "Path 42422",
    d: "M237.327,7.817a.382.382,0,0,0-.469-.3q-.971.242-1.919.566a24.86,24.86,0,0,1,.04,7.438,7.684,7.684,0,0,1-1.094,3.291,3.37,3.37,0,0,1-1.911,1.377.646.646,0,0,0-.35,1.03,5.069,5.069,0,0,0,.8.81.374.374,0,0,1,.127.4c-.705,2.378-3.627,6.322-6.377,7.29a1.786,1.786,0,0,0,.933.41c3.092.389,7.07-4.659,7.91-7.489a.374.374,0,0,0-.127-.4,5.142,5.142,0,0,1-1.33-1.628.108.108,0,0,1,.109-.157,3.067,3.067,0,0,0,2.682-1.432,7.685,7.685,0,0,0,1.094-3.291,24.855,24.855,0,0,0-.119-7.911Z",
    transform: "translate(-89.648 -6.883)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42423",
    "data-name": "Path 42423",
    d: "M180.4,320.966H168.233a1.233,1.233,0,1,1,0-2.466H180.4a1.233,1.233,0,1,1,0,2.466Z",
    transform: "translate(-35.335 -292.317)",
    fill: "#d4f2f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42424",
    "data-name": "Path 42424",
    d: "M302.466,318.5H300a1.233,1.233,0,1,1,0,2.466h2.466a1.233,1.233,0,0,0,0-2.466Z",
    transform: "translate(-157.402 -292.317)",
    fill: "#a6e7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42425",
    "data-name": "Path 42425",
    d: "M152.416,389.8h-13.1A3.313,3.313,0,0,1,136,386.488v-3.648a3.313,3.313,0,0,1,3.313-3.313h13.1a3.313,3.313,0,0,1,3.313,3.313v3.648A3.313,3.313,0,0,1,152.416,389.8Z",
    transform: "translate(-6.883 -348.328)",
    fill: "#f5c84b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42426",
    "data-name": "Path 42426",
    d: "M308.167,379.528H305.7a3.313,3.313,0,0,1,3.313,3.313v3.648A3.313,3.313,0,0,1,305.7,389.8h2.466a3.313,3.313,0,0,0,3.313-3.313v-3.648A3.313,3.313,0,0,0,308.167,379.528Z",
    transform: "translate(-162.634 -348.328)",
    fill: "#ce9d14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42427",
    "data-name": "Path 42427",
    d: "M136,423.809v3.32a3.313,3.313,0,0,0,3.313,3.313h13.1a3.313,3.313,0,0,0,3.313-3.313v-3.32Z",
    transform: "translate(-6.883 -388.969)",
    fill: "#f5c84b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42428",
    "data-name": "Path 42428",
    d: "M309.014,423.809v3.32a3.313,3.313,0,0,1-3.313,3.313h2.466a3.313,3.313,0,0,0,3.313-3.313v-3.32Z",
    transform: "translate(-162.634 -388.969)",
    fill: "#ce9d14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42429",
    "data-name": "Path 42429",
    d: "M190.615,348.5h10.75v2.551h-10.75Z",
    transform: "translate(-57.009 -319.851)",
    fill: "#a6e7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42430",
    "data-name": "Path 42430",
    d: "M291.385,348.5h2.466v2.551h-2.466Z",
    transform: "translate(-149.495 -319.851)",
    fill: "#6bd9e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42431",
    "data-name": "Path 42431",
    d: "M145.533,30.583h-.56V29.266h.092a1.85,1.85,0,0,0,0-3.7h-7.355q.116-.849.264-1.694c3.7-.348,7.076-5.13,7.99-7.948a.987.987,0,0,0-.332-1.053,4.456,4.456,0,0,1-.735-.753c2.329-.522,3.275-3.114,3.513-5.186a25.349,25.349,0,0,0-.122-8.108,1,1,0,0,0-1.225-.795,19.888,19.888,0,0,0-6.682,2.944.617.617,0,1,0,.723,1,18.424,18.424,0,0,1,6.013-2.684c.465,2.832.643,8.025-.918,10.495a2.473,2.473,0,0,1-2.113,1.17.725.725,0,0,0-.717,1.056,5.8,5.8,0,0,0,1.365,1.719c-.724,2.329-4,6.51-6.521,6.879a51.964,51.964,0,0,1,7.191-17.6.617.617,0,0,0-1.04-.663,53.2,53.2,0,0,0-7.369,18.059,1.751,1.751,0,0,1-.4-.42c-1.4-1.993-1.046-7.273-.539-9.708a5.5,5.5,0,0,0,1.935-.548.725.725,0,0,0,.082-1.237,1.655,1.655,0,0,1-.466-1.681A7.817,7.817,0,0,1,139.138,5.8a.617.617,0,1,0-.957-.778,9.043,9.043,0,0,0-1.772,3.485,3.062,3.062,0,0,0,.369,2.382,4.766,4.766,0,0,1-.992.174,1,1,0,0,0-.9.775c-.524,2.346-1.076,8.336.7,10.857a2.73,2.73,0,0,0,1.171.985q-.164.938-.289,1.883H132.9a1.85,1.85,0,0,0,0,3.7h.092v1.318h-.56a3.934,3.934,0,0,0-3.929,3.929V38.16a3.934,3.934,0,0,0,3.929,3.929h8.514a.617.617,0,0,0,0-1.233h-8.514a2.7,2.7,0,0,1-2.7-2.7v-2.7h18.5v2.7a2.7,2.7,0,0,1-2.7,2.7h-1.655a.617.617,0,0,0,0,1.233h1.655a3.934,3.934,0,0,0,3.929-3.929V34.512A3.934,3.934,0,0,0,145.533,30.583Zm-13.251-3.167a.617.617,0,0,1,.616-.617h12.166a.617.617,0,0,1,0,1.233H132.9A.617.617,0,0,1,132.281,27.416Zm1.941,1.85h9.517v1.318h-9.517Zm-1.793,2.551h13.1a2.7,2.7,0,0,1,2.681,2.407H129.749A2.7,2.7,0,0,1,132.429,31.816Z",
    transform: "translate(0 0)",
    fill: "#1b2737"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthor);
export default __webpack_public_path__ + "static/media/author.214fb4b2c68113424f1608b7276fbe2b.svg";
export { ForwardRef as ReactComponent };